import useSelectedStudent from "hooks/useSelectedStudent";

import styles from "./StudentSelect.module.css";

const StudentSelect = () => {
    const {
        students,
        error,
        isLoading,
        selectedStudentId,
        setSelectedStudentId,
    } = useSelectedStudent();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading parent data</div>;
    }

    return (
        <div className={styles.studentSelect}>
            {students.map((student) => (
                <div
                    key={student.emailAddress}
                    className={`${styles.studentSelectItem} ${
                        selectedStudentId === student.emailAddress
                            ? styles.active
                            : ""
                    }`}
                    onClick={() => setSelectedStudentId(student.emailAddress)}
                    onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            setSelectedStudentId(student.emailAddress);
                        }
                    }}
                    role="button"
                    tabIndex={0}
                    aria-pressed={selectedStudentId === student.emailAddress}
                >
                    <h2 className={styles.studentSelectName}>{student.name}</h2>
                </div>
            ))}
        </div>
    );
};

export default StudentSelect;
